// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Compromissos_AtualizaValorServicoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /compromissos/atualiza_valor_servico
 *
 * Validates input for updating a service value within a compromisso.
 */
import { registerContract } from './validate'

export interface Compromissos_AtualizaValorServicoInput {
id: number
valor: number
}

registerContract('Compromissos_AtualizaValorServicoInput', {
  id:    { type: 'number',  required: true },
  valor: { type: 'number',  required: true },
})
